import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import { getFeedNameListApi, getQualifyPropertiesForHabi, postSaveHistoryApi, postSendWhatsAppApi } from './api';

export const getPropertiesQualifyForHabi = createAsyncThunk(
    'qualify/properties',
    async (_: void, thunkAPI) => {
        const { qualify, User } = thunkAPI.getState() as RootState;
        return getQualifyPropertiesForHabi(User.token, qualify.filtersRequest);
    }
);

export const postSaveHistory = createAsyncThunk(
    'qualify/save_history',
    async (_: void, thunkAPI) => {
        const { qualify, User } = thunkAPI.getState() as RootState;
        const filters = {
            ...qualify.filters,
            city_id: qualify.filters.city_id.map((city) => city.city_id).toString(),
            broker_type: qualify.filters.broker_type.map((broker) => broker.id).toString(),
        };
        return postSaveHistoryApi(User.token, filters, qualify.rows_selected, qualify.exportOptions);
    }
);

export const postSendWhatsApp = createAsyncThunk(
    'qualify/send_whatsapp',
    async (rowSelected: number[], thunkAPI) => {
        const { User } = thunkAPI.getState() as RootState;
        return postSendWhatsAppApi(User.token, rowSelected);
    }
);

export const getFeedNameList = createAsyncThunk(
    'qualify/get_feed_list',
    async (_: void, thunkAPI) => {
        const { User } = thunkAPI.getState() as RootState;
        return getFeedNameListApi(User.token);
    }
);
